import { getTokenMillisecondsLeft } from './get-token-milliseconds-left';
/**
 * Determines whether JWT is expired
 * @param token JWT to check expiration for
 * @returns A boolean value indicating whether JWT is expired
 */
export var isTokenExpired = function (token) {
    return getTokenMillisecondsLeft(token) <= 0;
};
